import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks';

export default () => {
    const { response: { query }} = useAppState();

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ "nostocategory-no-results" ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    return (
        <>
            <div class="ns-text-align-center ns-my-5 ns-mx-0">
                <div class="ns-font-4">No results found for '{query}'</div>
            </div>
            <div class="nosto_element" id="nostocategory-no-results"></div>
        </>

    )
}
